import type { StreamModel } from 'player/model/stream';

/**
 * Podcast mp4 urls are delivered with an Acast prepend (an audio ad) in front
 * of the real url. It is kept only when the user is served ads; otherwise it
 * is removed.
 */
export function getPodcastMp4Url(
    stream: StreamModel,
    { keepAcastPrepend }: { keepAcastPrepend: boolean },
): string[] {
    const urls = stream.getUrl('mp4') as string[];

    if (keepAcastPrepend || !Array.isArray(urls)) {
        return urls;
    }

    const prependUrl = stream.getCategory()?.getAcastPrependUrl();

    if (!prependUrl || !urls[0]?.startsWith(prependUrl)) {
        return urls;
    }

    return [`https://${urls[0].replace(prependUrl, '')}`, ...urls.slice(1)];
}
